var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinux({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6198 8.35C14.1998 8.63 12.8698 9.39 12.6698 9.54C12.2798 9.85 11.9198 9.83 11.5298 9.53C11.3298 9.37 9.99984 8.61 9.57984 8.34C9.09984 8.03 9.12984 7.64 9.65984 7.42C11.2998 6.73 12.9398 6.78 14.5698 7.45C15.0598 7.66 15.0798 8.05 14.6198 8.35ZM21.8398 15.63C20.9098 13.54 19.6398 11.64 17.9998 9.97C17.4928 9.44337 17.128 8.79642 16.9398 8.09C16.8398 7.76 16.7698 7.42 16.6998 7.08C16.4998 6.2 16.4098 5.3 15.9998 4.47C15.2698 2.89 13.9998 2.07 12.1598 2C10.3498 2.05 8.99984 2.81 8.20984 4.4C7.99984 4.83 7.84984 5.28 7.74984 5.74C7.57984 6.5 7.42984 7.29 7.24984 8.06C7.09984 8.71 6.79984 9.27 6.28984 9.77C4.67984 11.34 3.38984 13.14 2.40984 15.12C2.26984 15.41 2.12984 15.7 2.03984 16C1.84984 16.66 2.32984 17.12 3.02984 16.96C3.46984 16.87 3.90984 16.78 4.32984 16.65C4.73984 16.5 4.89984 16.6 4.99984 17C5.64984 19.15 7.06984 20.66 9.23984 21.5C13.3598 23.06 18.1698 20.84 19.2098 16.92C19.2798 16.65 19.3798 16.55 19.6798 16.65C20.1398 16.79 20.6098 16.89 21.0798 17C21.5698 17.09 21.9298 16.84 21.9998 16.36C22.0298 16.1 21.9398 15.87 21.8398 15.63Z",
    fill: "#455079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinux);
export default __webpack_public_path__ + "static/media/linux.6434733d4989285109dc1c86a11215ec.svg";
export { ForwardRef as ReactComponent };